import { createAction, props } from '@ngrx/store';

export const updateExternalCustomerSubscriptions = createAction(
  '[Customers] Update External Customer Subscriptions',
  props<{ groupId: string }>(),
);

export const updateExternalCustomerSubscriptionsSuccess = createAction(
  '[Customers] Update External Customer Subscriptions Success',
);

export const updateExternalCustomerSubscriptionsFailure = createAction(
  '[Customers] Update External Customer Subscriptions Failure',
  props<{ error: any }>(),
);
